import React from 'react';

import TeacherBaseCard from 'parent-portal/providers/cards/shared/TeacherBaseCard';
import { ITeacher } from 'models/Providers/Teacher';
import PublicTeacherCardHeader from './PublicTeacherCardHeader';
import { Grid, styled } from '@mui/material';
import { Text } from 'library';
import SmallRating from 'parent-portal/providers/cards/shared/SmallRating';

export default function PublicTeacherCard({ worker }: { worker: ITeacher }) {
    return (
        <TeacherBaseCard
            worker={worker}
            header={<PublicTeacherCardHeader worker={worker} />}
            showName={false}
            details={
                <Grid position="relative" height={120} justifyContent="flex-end" flexDirection="column">
                    <RatingContainer>
                        <SmallRating reviews={worker.credentials.reviews} />
                    </RatingContainer>
                    <NameContainer>
                        <Text variant="h1">{worker.name}</Text>
                    </NameContainer>
                    <Text
                        variant="caption"
                        textStyle={{
                            overflow: 'hidden',
                            WebkitLineClamp: 3,
                            textOverflow: 'ellipsis',
                            WebkitBoxOrient: 'vertical',
                            display: '-webkit-box',
                            margin: 10,
                            lineHeight: 1.4,
                        }}
                    >
                        {worker.bio ?? ''}
                    </Text>
                </Grid>
            }
        />
    );
}

const RatingContainer = styled('div')({
    position: 'absolute',
    top: -50,
    right: 0,
});

const NameContainer = styled('div')({
    paddingLeft: 10,
    paddingTop: 28,
});
